import React, { useState, Fragment } from "react";

import NavMenuDesktop from "../common/NavMenuDesktop";
import NavMenuMobile from "../common/NavMenuMobile";

import FooterDesktop from "../common/FooterDesktop";
import FooterMobile from "../common/FooterMobile";

import "../../assests/css/ContactUs.css";


function ContactUs() {

    const [name, setName] = useState("");
    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");


    const handleSubmit = (event) => {

        event.preventDefault();

        const whatsappMessage = `
Hello Prime Luxury,

My Name: ${name}

Phone Number: ${phone}

Email: ${email}

Message:
${message}
        `;


        const whatsappURL =
            "https://wa.me/971501011783?text=" +
            encodeURIComponent(whatsappMessage.trim());


        window.open(
            whatsappURL,
            "_blank",
            "noopener,noreferrer"
        );

    };


    return (

        <Fragment>

            {/* ================= DESKTOP HEADER ================= */}

            <div className="Desktop">

                <NavMenuDesktop />

            </div>


            {/* ================= MOBILE HEADER ================= */}

            <div className="Mobile">

                <NavMenuMobile />

            </div>


            {/* ================= CONTACT PAGE ================= */}

            <section className="contact-page">


                {/* ================= HEADER ================= */}

                <div className="contact-header">

                    <span className="contact-label">
                        PRIME LUXURY
                    </span>

                    <h1>
                        Contact Us
                    </h1>

                    <p>
                        Get in touch with Prime Luxury Passenger
                        Transport LLC for premium chauffeur,
                        limousine and airport transfer services
                        in Dubai.
                    </p>

                </div>


                {/* ================= MAIN CONTENT ================= */}

                <div className="contact-container">


                    {/* ================= CONTACT INFO ================= */}

                    <div className="contact-info">


                        <div className="contact-info-header">

                            <span>
                                GET IN TOUCH
                            </span>

                            <h2>
                                We're Here to Help
                            </h2>

                            <p>
                                Contact our team for bookings,
                                enquiries and premium transportation
                                services in Dubai.
                            </p>

                        </div>


                        {/* ================= PHONE ================= */}

                        <div className="contact-info-item">

                            <div className="contact-icon">

                                <i className="fa fa-phone"></i>

                            </div>

                            <div>

                                <small>
                                    CALL US
                                </small>

                                <a href="tel:+971501011783">
                                    +971 50 101 1783
                                </a>

                            </div>

                        </div>


                        {/* ================= WHATSAPP ================= */}

                        <div className="contact-info-item">

                            <div className="contact-icon whatsapp">

                                <i className="fab fa-whatsapp"></i>

                            </div>

                            <div>

                                <small>
                                    WHATSAPP
                                </small>

                                <a
                                    href="https://wa.me/971501011783"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Chat With Us
                                </a>

                            </div>

                        </div>


                        {/* ================= EMAIL ================= */}

                        <div className="contact-info-item">

                            <div className="contact-icon">

                                <i className="fa fa-envelope"></i>

                            </div>

                            <div>

                                <small>
                                    EMAIL US
                                </small>

                                <a href="mailto:info@dxblimo.com">
                                    booking@dxblimo.com
                                </a>

                            </div>

                        </div>


                        {/* ================= LOCATION ================= */}

                        <div className="contact-info-item">

                            <div className="contact-icon">

                                <i className="fa fa-map-marker-alt"></i>

                            </div>

                            <div>

                                <small>
                                    LOCATION
                                </small>

                                <p>
                                    Dubai, United Arab Emirates
                                </p>

                            </div>

                        </div>


                    </div>


                    {/* ================= CONTACT FORM ================= */}

                    <div className="contact-form-card">

                        <span className="contact-form-label">
                            SEND US A MESSAGE
                        </span>

                        <h2>
                            How Can We Help?
                        </h2>


                        <form onSubmit={handleSubmit}>


                            {/* NAME */}

                            <div className="contact-form-group">

                                <label>
                                    Your Name
                                </label>

                                <input
                                    type="text"
                                    placeholder="Enter your name"
                                    value={name}
                                    onChange={(e) =>
                                        setName(e.target.value)
                                    }
                                    required
                                />

                            </div>


                            {/* PHONE */}

                            <div className="contact-form-group">

                                <label>
                                    Phone Number
                                </label>

                                <input
                                    type="tel"
                                    placeholder="+971 XX XXX XXXX"
                                    value={phone}
                                    onChange={(e) =>
                                        setPhone(e.target.value)
                                    }
                                    required
                                />

                            </div>


                            {/* EMAIL */}

                            <div className="contact-form-group">

                                <label>
                                    Email Address
                                </label>

                                <input
                                    type="email"
                                    placeholder="Enter your email"
                                    value={email}
                                    onChange={(e) =>
                                        setEmail(e.target.value)
                                    }
                                    required
                                />

                            </div>


                            {/* MESSAGE */}

                            <div className="contact-form-group">

                                <label>
                                    Your Message
                                </label>

                                <textarea
                                    rows="5"
                                    placeholder="Tell us how we can help you..."
                                    value={message}
                                    onChange={(e) =>
                                        setMessage(e.target.value)
                                    }
                                    required
                                />

                            </div>


                            {/* WHATSAPP BUTTON */}

                            <button
                                type="submit"
                                className="contact-submit-button"
                            >

                                <i className="fab fa-whatsapp"></i>

                                Send via WhatsApp

                            </button>


                        </form>

                    </div>


                </div>


                {/* ================= MAP ================= */}

                <div className="contact-map-section">


                    <div className="contact-map-header">

                        <span>
                            OUR LOCATION
                        </span>

                        <h2>
                            Visit Prime Luxury
                        </h2>

                        <p>
                            Find our location and get directions
                            using Google Maps.
                        </p>

                    </div>


                    {/* ================= GOOGLE MAP ================= */}

                    <div className="contact-map">

                        <iframe
                            title="Prime Luxury Location"
                            src="https://www.google.com/maps?q=Dubai,United%20Arab%20Emirates&output=embed"
                            width="100%"
                            height="450"
                            style={{ border: 0 }}
                            allowFullScreen
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                        />

                    </div>


                    {/* ================= GOOGLE MAP BUTTON ================= */}

                    <div className="contact-map-button-wrapper">

                        <a
                            href="https://share.google/uSz3EfnJMXTmFWXUe"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="contact-map-button"
                        >

                            <i className="fa fa-map-marker-alt"></i>

                            Open Location in Google Maps

                        </a>

                    </div>


                </div>


            </section>


            {/* ================= DESKTOP FOOTER ================= */}

            <div className="Desktop">

                <FooterDesktop />

            </div>


            {/* ================= MOBILE FOOTER ================= */}

            <div className="Mobile">

                <FooterMobile />

            </div>


        </Fragment>

    );

}


export default ContactUs;